import { Toggleable } from 'sane-ui'
import { Power3, Power0 } from 'gsap'

class DrawerNav extends Toggleable {
  constructor ($el, args) {
    super($el, args)
    this.$drawerNav = $('#global-scrim')

    this.timeline
      .to(this.$el, 0.001, { autoAlpha: 1 })
      .to(this.$el, 0.4, { x: 0, ease: Power3.easeInOut }, 0)
      .to(this.$drawerNav, 0.4, { autoAlpha: 1, ease: Power0.easeNone }, 0)

    this.onToggle = this.onToggle.bind(this)
    this.$el.on('Toggleable/toggle', this.onToggle)
  }

  onToggle (event, isOpen) {
    if (isOpen) {
      this.$drawerNav.one('click', this.close)
    } else {
      this.$drawerNav.off('click', this.close)
    }
  }
}

export default DrawerNav



// WEBPACK FOOTER //
// ./scripts/components/DrawerNav.js